<!-- Render <a> only if there is a URL -->
@if (isLink) {
  @if (routerLink) {
    <a
      [routerLink]="routerLink"
      [href]="computedHref"
      [attr.aria-label]="ariaLabel"
      [attr.target]="target"
      [attr.rel]="hostRel"
      [ngClass]="[variant, color, underline, active ? 'active' : '']"
      class="link-wrapper"
      >
      <hyperkit-typography
        [variant]="variant"
        [size]="size"
        color="inherit"
        [display]="display"
        >
        {{ text }}
      </hyperkit-typography>
    </a>
  } @else {
    <a
      [href]="computedHref"
      [attr.aria-label]="ariaLabel"
      [attr.target]="target"
      [attr.rel]="hostRel"
      [ngClass]="[variant, color, underline, active ? 'active' : '']"
      class="link-wrapper"
      >
      <hyperkit-typography
        [variant]="variant"
        [size]="size"
        color="inherit"
        [display]="display"
        >
        {{ text }}
      </hyperkit-typography>
    </a>
  }
} @else {
  <span
    [ngClass]="[variant, color, underline, active ? 'active' : '']"
    class="link-wrapper"
    >
    <hyperkit-typography
      [variant]="variant"
      [size]="size"
      color="inherit"
      [display]="display"
      >
      {{ text }}
    </hyperkit-typography>
  </span>
}

<!-- Render <span> if no href or routerLink -->
